(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PhoseiDailyOutlook = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const MIN_YEAR = 1900;
  const MAX_YEAR = 2100;
  const CNY_DATES = '0131,0219,0208,0129,0216,0204,0125,0213,0202,0122,0210,0130,0218,0206,0126,0214,0203,0123,0211,0201,0220,0208,0128,0216,0205,0124,0213,0202,0123,0210,0130,0217,0206,0126,0214,0204,0124,0211,0131,0219,0208,0127,0215,0205,0125,0213,0202,0122,0210,0129,0217,0206,0127,0214,0203,0124,0212,0131,0218,0208,0128,0215,0205,0125,0213,0202,0121,0209,0130,0217,0206,0127,0215,0203,0123,0211,0131,0218,0207,0128,0216,0205,0125,0213,0202,0220,0209,0129,0217,0206,0127,0215,0204,0123,0210,0131,0219,0207,0128,0216,0205,0124,0212,0201,0122,0209,0129,0218,0207,0126,0214,0203,0123,0210,0131,0219,0208,0128,0216,0205,0125,0212,0201,0122,0210,0129,0217,0206,0126,0213,0203,0123,0211,0131,0219,0208,0128,0215,0204,0124,0212,0201,0122,0210,0130,0217,0206,0126,0214,0202,0123,0211,0201,0219,0208,0128,0215,0204,0124,0212,0202,0121,0209,0129,0217,0205,0126,0214,0203,0123,0211,0131,0219,0207,0127,0215,0205,0124,0212,0202,0122,0209,0129,0217,0206,0126,0214,0203,0124,0210,0130,0218,0207,0127,0215,0205,0125,0212,0201,0121,0209'.split(',');

  const SUN_SIGNS = [
    { name: 'Capricorn', start: 1222 },
    { name: 'Aquarius', start: 120 },
    { name: 'Pisces', start: 219 },
    { name: 'Aries', start: 321 },
    { name: 'Taurus', start: 420 },
    { name: 'Gemini', start: 521 },
    { name: 'Cancer', start: 621 },
    { name: 'Leo', start: 723 },
    { name: 'Virgo', start: 823 },
    { name: 'Libra', start: 923 },
    { name: 'Scorpio', start: 1023 },
    { name: 'Sagittarius', start: 1122 }
  ];

  const ZODIAC = [
    { branch: '子', animal: 'Rat' },
    { branch: '丑', animal: 'Ox' },
    { branch: '寅', animal: 'Tiger' },
    { branch: '卯', animal: 'Rabbit' },
    { branch: '辰', animal: 'Dragon' },
    { branch: '巳', animal: 'Snake' },
    { branch: '午', animal: 'Horse' },
    { branch: '未', animal: 'Goat' },
    { branch: '申', animal: 'Monkey' },
    { branch: '酉', animal: 'Rooster' },
    { branch: '戌', animal: 'Dog' },
    { branch: '亥', animal: 'Pig' }
  ];

  const THEMES = [
    'Clarify before you commit',
    'Protect the pace that keeps you clear',
    'Choose one useful conversation',
    'Notice what is asking for less effort',
    'Make room for a better question',
    'Finish the smallest meaningful step',
    'Review the pattern before repeating it'
  ];

  const WESTERN_LENSES = [
    'Use your natural directness to name the real priority, then leave enough room to hear a different view.',
    'Stability matters today, but staying steady does not require holding on to every familiar detail.',
    'Curiosity opens useful options. Capture the strongest idea before another possibility replaces it.',
    'Check whether care has quietly become over-responsibility. Support can include a clear boundary.',
    'Visibility is useful when it serves the work. Let one deliberate action speak louder than extra performance.',
    'Discernment is sharp today. Apply it to the next practical step rather than trying to perfect the whole plan.',
    'Balance is easier when the trade-off is named. Say what you are weighing instead of smoothing it over.',
    'Intensity can reveal what matters. Give the feeling a specific question before turning it into a conclusion.',
    'A wider view helps, but one grounded commitment will carry the insight further than another new direction.',
    'Structure can create freedom today. Choose the boundary that protects the work you most want to complete.',
    'A fresh perspective is useful when it becomes shareable. Translate the unusual idea into one clear next move.',
    'Sensitivity is information, not an instruction. Notice the atmosphere, then decide from your own centre.'
  ];

  const ZODIAC_LENSES = [
    'The Rat lens favours resourcefulness. Look for the overlooked connection before adding more resources.',
    'The Ox lens favours patient progress. Strengthen the foundation before asking the plan to move faster.',
    'The Tiger lens favours initiative. Direct courage toward one chosen risk instead of reacting to every challenge.',
    'The Rabbit lens favours tact and timing. A softer approach may reveal information that pressure would hide.',
    'The Dragon lens favours scale and conviction. Test the large idea against one concrete constraint.',
    'The Snake lens favours observation. Let the pattern become clear before you explain or expose it.',
    'The Horse lens favours movement. Choose motion that creates direction, not activity that only relieves impatience.',
    'The Goat lens favours refinement and care. Improve the environment around the decision before forcing an answer.',
    'The Monkey lens favours experimentation. Try the reversible version first and learn from the response.',
    'The Rooster lens favours precision. Name the standard clearly, then separate what is essential from what is cosmetic.',
    'The Dog lens favours loyalty and principle. Check whether the commitment is still mutual and still useful.',
    'The Pig lens favours openness and generosity. Keep the heart open while making the terms unmistakably clear.'
  ];

  const SHARED_PATTERNS = [
    'Both lenses point toward selective attention: fewer signals, read more carefully.',
    'The common thread is pacing. A considered pause can improve the quality of the next move.',
    'Both perspectives favour a clear exchange over silent assumptions.',
    'The shared invitation is to distinguish genuine responsibility from habitual pressure.',
    'Both lenses support one visible, proportionate action rather than a dramatic leap.',
    'The common pattern is refinement: adjust the method before changing the goal.',
    'Both perspectives ask you to name the trade-off and choose it consciously.'
  ];

  const PROMPTS = [
    'What deserves your full attention today—and what can wait?',
    'Which pace would help you make a clearer decision?',
    'What conversation becomes easier once you name the real question?',
    'Where are you carrying responsibility that was never clearly agreed?',
    'What is the smallest action that would make your intention visible?',
    'Which part of the process needs adjustment before you change direction?',
    'What trade-off are you already making without admitting it?'
  ];

  const parseCalendarDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    if (!match) throw new RangeError('Enter a valid birth date.');
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
      throw new RangeError('Enter a valid birth date.');
    }
    return { value: `${match[1]}-${match[2]}-${match[3]}`, year, month, day, date };
  };

  const parseBirthDate = (value, todayValue) => {
    const birth = parseCalendarDate(value);
    const today = parseCalendarDate(todayValue || new Date().toISOString().slice(0, 10));
    if (birth.year < MIN_YEAR || birth.year > MAX_YEAR) {
      throw new RangeError('Enter a birth date between 1900 and 2100.');
    }
    if (birth.date > today.date) throw new RangeError('Your birth date cannot be in the future.');
    return birth;
  };

  const resolveSunSign = (value) => {
    const date = parseCalendarDate(value);
    const monthDay = date.month * 100 + date.day;
    if (monthDay >= 1222 || monthDay < 120) return { ...SUN_SIGNS[0], index: 0 };
    let sign = SUN_SIGNS[1];
    for (const candidate of SUN_SIGNS.slice(1)) {
      if (monthDay >= candidate.start) sign = candidate;
    }
    return { ...sign, index: SUN_SIGNS.indexOf(sign) };
  };

  const resolveChineseZodiac = (value) => {
    const birth = parseCalendarDate(value);
    if (birth.year < MIN_YEAR || birth.year > MAX_YEAR) {
      throw new RangeError('Enter a birth date between 1900 and 2100.');
    }
    const boundary = Number(CNY_DATES[birth.year - MIN_YEAR]);
    const monthDay = birth.month * 100 + birth.day;
    const zodiacYear = monthDay < boundary ? birth.year - 1 : birth.year;
    const index = ((zodiacYear - 2020) % 12 + 12) % 12;
    return { ...ZODIAC[index], index, year: zodiacYear };
  };

  const dayNumber = (value) => Math.floor(parseCalendarDate(value).date.getTime() / 86400000);

  const getDailyOutlook = (birthValue, todayValue) => {
    const today = todayValue || new Date().toISOString().slice(0, 10);
    const birth = parseBirthDate(birthValue, today);
    const sunSign = resolveSunSign(birth.value);
    const zodiac = resolveChineseZodiac(birth.value);
    const dailyIndex = ((dayNumber(today) % THEMES.length) + THEMES.length) % THEMES.length;

    return {
      date: today,
      sunSign,
      zodiac,
      theme: THEMES[dailyIndex],
      westernLens: WESTERN_LENSES[(sunSign.index + dailyIndex) % WESTERN_LENSES.length],
      zodiacLens: ZODIAC_LENSES[(zodiac.index + dailyIndex) % ZODIAC_LENSES.length],
      sharedPattern: SHARED_PATTERNS[dailyIndex],
      practicalPrompt: PROMPTS[dailyIndex]
    };
  };

  return {
    MIN_YEAR,
    MAX_YEAR,
    parseBirthDate,
    resolveSunSign,
    resolveChineseZodiac,
    getDailyOutlook
  };
});
